import React from 'react';
import clsx from 'clsx';
import { DivPropsWithoutRef } from '../../common';

export interface DropdownMenuMessageProps extends DivPropsWithoutRef {};

export const DropdownMenuMessage: React.FC<DropdownMenuMessageProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div className={clsx(className, 'hse-DropdownMenuMessage')} {...props}>
      {children}
    </div>
  );
};
